import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface UserData {
    id: number;
    username: string;
    email: string;
    role: boolean;
    isActive: boolean;
}

const Navdata = () => {
    const history = useNavigate();

    //state data
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isEmployee, setIsEmployee] = useState<boolean>(false);
    const [isPayroll, setIsPayroll] = useState<boolean>(false);
    const [isAttendance, setIsAttendance] = useState<boolean>(false);
    const [isSalaryAttendance, setIsSalaryAttendance] = useState<boolean>(false);
    const [isLeave, setIsLeave] = useState<boolean>(false);
    const [isReports, setIsReports] = useState<boolean>(false);
    const [isSettings, setIsSettings] = useState<boolean>(false);
    const [isUserManagement, setIsUserManagement] = useState<boolean>(false);
    const [isMasters, setIsMasters] = useState<boolean>(false);
    const [isSignOut, setIsSignOut] = useState<boolean>(false);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    // Check user role on component mount
    useEffect(() => {
        const userDataString = localStorage.getItem("user");
        if (userDataString) {
            try {
                const user: UserData = JSON.parse(userDataString);
                setIsAdmin(user.role === true);
            } catch (error) {
                console.error("Error parsing user data:", error);
                setIsAdmin(false);
            }
        }
    }, []);

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    // Function to handle logout
    const handleLogout = () => {
        // Clear all auth data
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        history("/login");
    };

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Employee') {
            setIsEmployee(false);
        }
        if (iscurrentState !== 'Payroll') {
            setIsPayroll(false);
        }
        if (iscurrentState !== 'Attendance') {
            setIsAttendance(false);
        }
        if (iscurrentState !== 'SalaryAttendance') {
            setIsSalaryAttendance(false);
        }
        if (iscurrentState !== 'Leave') {
            setIsLeave(false);
        }
        if (iscurrentState !== 'Reports') {
            setIsReports(false);
        }
        if (iscurrentState !== 'Settings') {
            setIsSettings(false);
        }
        if (iscurrentState !== 'UserManagement') {
            setIsUserManagement(false);
        }
        if (iscurrentState !== 'Masters') {
            setIsMasters(false);
        }
        if (iscurrentState !== 'SignOut') {
            setIsSignOut(false);
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isEmployee,
        isPayroll,
        isAttendance,
        isSalaryAttendance,
        isLeave,
        isReports,
        isSettings,
        isUserManagement,
        isMasters,
        isSignOut
    ]);

    // Base menu items that are common for all users
    const baseMenuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        // Dashboard
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-2-line",
            link: "/dashboard",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('Dashboard');
                history("/dashboard");
            },
        },
        // Employee Management
        {
            id: "employee",
            label: "Employee",
            icon: "ri-team-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsEmployee(!isEmployee);
                setIscurrentState('Employee');
                updateIconSidebar(e);
            },
            stateVariables: isEmployee,
            subItems: [
                {
                    id: "employee-master",
                    label: "Employee Master",
                    link: "/employees",
                    parentId: "employee",
                },
                {
                    id: "employee-add",
                    label: "Add Employee ",
                    link: "/create-employee",
                    parentId: "employee",
                },
                {
                    id: "employee-leave-policy",
                    label: "Employee Leave policy",
                    link: "/employee-leave-policy",
                    parentId: "employee",
                },

            ],
        },

        {
            id: "attendance",
            label: "Register Attendance",
            icon: "ri-calendar-check-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsAttendance(!isAttendance);
                setIscurrentState('Attendance');
                updateIconSidebar(e);
            },
            stateVariables: isAttendance,
            subItems: [
                {
                    id: "today-attendance",
                    label: "Today Attendance",
                    link: "/today-attendance",
                    parentId: "attendance",
                },
                {
                    id: "mark-attendance",
                    label: "Monthly Attendance",
                    link: "/attendance",
                    parentId: "attendance",
                },
                {
                    id: "leave-request",
                    label: "Leave Request",
                    link: "/leaverequest",
                    parentId: "attendance",
                },
                {
                    id: "loss-of-pay",
                    label: "Loss of pay ",
                    link: "/loss-of-pay",
                    parentId: "attendance",
                },
                // {
                //     id: "attendance-summary",
                //     label: "Sunday Attendance",
                //     link: "/attendance-summary",
                //     parentId: "attendance",
                // },
            ],
        },
        // Salary Attendance
        {
            id: "salary-attendance",
            label: "Salary Attendance",
            icon: "ri-coins-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsSalaryAttendance(!isSalaryAttendance);
                setIscurrentState('SalaryAttendance');
                updateIconSidebar(e);
            },
            stateVariables: isSalaryAttendance,
            subItems: [
                {
                    id: "monthly-salary",
                    label: "Monthly Salary",
                    link: "/monthly-salary",
                    parentId: "salary-attendance",
                },
                // {
                //     id: "ot-salary",
                //     label: "OT Salary",
                //     link: "/ot-salary",
                //     parentId: "salary-attendance",
                // },
                // {
                //     id: "sunday-salary",
                //     label: "Sunday Salary",
                //     link: "/sunday-salary",
                //     parentId: "salary-attendance",
                // },
            ],
        },

        // Reports
        {
            id: "reports",
            label: "Reports",
            icon: "ri-bar-chart-2-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsReports(!isReports);
                setIscurrentState('Reports');
                updateIconSidebar(e);
            },
            stateVariables: isReports,
            subItems: [
                {
                    id: "esi-pf-report",
                    label: "ESI/PF Report",
                    link: "/epf-esi",
                    parentId: "reports",
                },
            ],
        },
        // Settings
        {
            id: "settings",
            label: "Settings",
            icon: "ri-settings-3-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsSettings(!isSettings);
                setIscurrentState('Settings');
                updateIconSidebar(e);
            },
            stateVariables: isSettings,
            subItems: [
                {
                    id: "company-settings",
                    label: "Company Settings",
                    link: "/company-setting",
                    parentId: "settings",
                },
                {
                    id: "epf-settings",
                    label: "EPF Settings",
                    link: "/epf-percentage",
                    parentId: "settings",
                },
                {
                    id: "holiday-settings",
                    label: "Holiday Settings",
                    link: "/holiday-settings",
                    parentId: "settings",
                },
                {
                    id: "leavepolicies-settings",
                    label: "Leave Policies",
                    link: "/leave-policies",
                    parentId: "settings",
                },
            ],
        },
        {
            id: "masters",
            label: "Masters",
            icon: "ri-database-2-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsMasters(!isMasters);
                setIscurrentState('Masters');
                updateIconSidebar(e);
            },
            stateVariables: isMasters,
            subItems: [
                {
                    id: "designation-master",
                    label: "Designation",
                    link: "/designation-master",
                    parentId: "masters",
                },
                {
                    id: "unit-master",
                    label: "company",
                    link: "/unit-master",
                    parentId: "masters",
                },
                {
                    id: "bank-master",
                    label: "Bank",
                    link: "/bank-master",
                    parentId: "masters",
                },
                {
                    id: "office-location-master",
                    label: "Office Location",
                    link: "/officelocation-master",
                    parentId: "masters",
                },
                {
                    id: "leave-type",
                    label: "Leave Types",
                    link: "/leave-types",
                    parentId: "masters",
                },

            ],
        },
        {
            id: "user-management",
            label: "User Management",
            icon: "ri-user-settings-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsUserManagement(!isUserManagement);
                setIscurrentState('UserManagement');
                updateIconSidebar(e);
            },
            stateVariables: isUserManagement,
            subItems: [
                {
                    id: "admin-users",
                    label: "Admin Users",
                    link: "/profile-setting",
                    parentId: "user-management",
                },
            ],
        },
    ];

    // Logout menu item (common for all)
    const logoutMenuItem: any = {
        id: "logout",
        label: "Logout",
        icon: "ri-logout-box-line",
        link: "/#",
        click: function (e: any) {
            e.preventDefault();
            setIsSignOut(!isSignOut);
            setIscurrentState('SignOut');

            // Show logout confirmation modal
            const logoutEvent = new CustomEvent('showLogoutModal', {
                detail: { onConfirm: handleLogout }
            });
            window.dispatchEvent(logoutEvent);
        },
    };

    // Combine menu items based on user role
    const menuItems = isAdmin
        ? [...baseMenuItems, logoutMenuItem]
        : [...baseMenuItems, logoutMenuItem];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;